export default "__VITE_ASSET__C4L7gKlS__"